<template>
    <div>
        <div class="creator-search-results__accordion-header debug" @click="toggleAccordion(title)">
            <h3>{{ title === 'Portmanteau' ? 'Word Combi Results' : title + ' Results' }} ({{ data.length }})</h3>


            <InlineSvg :src="require(`../../assets/svgs/down-arrow-black.svg`)"
                class="creator-search-results__accordion-arrow" />
        </div>

        <div class="creator-search-results__accordion-body" style="display: none;" :ref="title + 'AccordionBody'">
            <div class="creator-search-results__checkboxes">
                <div v-for="(item, index) in pageData" :key="index" class="creator-search-results__checkbox-wrapper">
                    <label class="creator-search-results__checkbox-label">
                        <input type="checkbox" :value="removeFromString(['german-', 'french-', 'swedish-', 'spanish-', 'italian-',],item)" @change="checkboxChangeHandler($event)"
                            class="creator-search-results__checkbox-input"
                            :checked="wordBank.some(wordData => wordData.name.toLowerCase() === item.toLowerCase())">
                        <span class="creator-search-results__checkbox-checkmark"></span>
                        <span class="creator-search-results__checkbox-text">{{ item }}</span>
                    </label>
                </div>
            </div>

            <div class="creator-search-results__accordion-copy" v-if="data.length == 0">
                <span v-if="title == 'Rhyme'">
                    Try your search again – the rhyme tool will only work with a single word with a known meaning.
                </span>
                <span v-else-if="title == 'Associate'">
                    Try your search again – the associate tool will only work with a single word with a known meaning.
                </span>
                <span v-else>
                    Try your search again, perhaps you could try adding some spaces or a different word entirely!
                </span>
            </div>

            <Paginator :rows="24" :totalRecords="this.data.length" @page="changePage"></Paginator>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import { mapGetters, mapActions } from "vuex";
import InlineSvg from 'vue-inline-svg';
import Paginator from 'primevue/paginator';

export default {
    name: 'CreatorAccordion',
    components: {
        InlineSvg,
        Paginator
    },
    props: ['data', 'title'],
    data() {
        return {
            selectedWords: [],
            offset: 24,
            page: 1,
            totalPages: Math.ceil(this.data.length / 24),
            definition: '',
            showDefintionModal: false,
            definitionWord: '',
        }
    },
    computed: {
        ...mapGetters('BrandCentre', {
            wordBank: 'getWordBankWords',
        }),
        pageData() {
            let start = 0;
            let end = 24;

            if (this.page != 1) {
                start = ((this.page - 1) * this.offset);
                end = Math.abs((this.page * this.offset));
            }

            return this.data.slice(start, end)
        }
    },
    watch: {
        selectedWords: function (data) {
            this.$emit('wordbank-updated', data);
        }
    },
    methods: {
        ...mapActions('BrandCentre', {
            addWordToWordBank: 'addWordToWordBank',
            removeWordBankWord: 'removeWordBankWord'
        }),
        toggleAccordion(key) {
            $(this.$refs[key + 'AccordionBody']).prev().toggleClass('creator-search-results__accordion-header--open');
            $(this.$refs[key + 'AccordionBody']).slideToggle();
        },
        checkboxChangeHandler(e) {
            console.log('bean ' + e.target.value);

            if (e.target.checked) {
                this.$store.dispatch('BrandCentre/addWordToWordBank', e.target.value);
            } else {
                this.$store.dispatch('BrandCentre/removeWordBankWord', e.target.value);
            }
        },
        changePage(pageStatus) {
            const pageNumber = pageStatus.page + 1; // add 1 due to .page starting at zero
            this.page = pageNumber;
        },
        removeFromString(arr, str) {
            let regex = new RegExp("\\b" + arr.join('|') + "\\b", "gi")
            return str.replace(regex, '')
        }
    }
}
</script>
